import { lazy } from 'react';
// @ts-ignore
export const AdminHomeScreenAsync = lazy(() => import('./AdminHomeScreen.tsx'));
